/**
 * Tracciamento dell'avvio, spento di default.
 *
 * La navigazione iniziale è quella che vue-router avvia da solo dentro `app.use(router)`:
 * parte prima che si possa agganciare qualcosa dalla console, e se non si chiude lascia
 * la pagina sul loader senza lasciare traccia (in produzione vue-router ingoia l'errore,
 * perché il suo `warn` è compilato via). Questo modulo permette di seguirla passo passo.
 *
 * Per attivarlo, nella console del browser:
 *
 *     localStorage.setItem('boot-trace', '1'); location.reload();
 *
 * Per spegnerlo:
 *
 *     localStorage.removeItem('boot-trace');
 */

let enabled = false;

try {
	enabled = window.localStorage.getItem('boot-trace') === '1';
} catch {
	// storage non disponibile: il tracciamento resta spento
}

const t0 = typeof performance !== 'undefined' ? performance.now() : 0;

export function bootTrace(step: string, detail?: unknown): void {
	if (!enabled) return;
	const ms = Math.round((typeof performance !== 'undefined' ? performance.now() : 0) - t0);
	if (detail === undefined) {
		console.log(`[boot +${ms}ms] ${step}`);
	} else {
		console.log(`[boot +${ms}ms] ${step}`, detail);
	}
}

export const bootTraceEnabled = enabled;
